export const INPUT_FIELD_MAX_LENGTH = 255;
